import React from "react";
import { Box, Typography, Divider, Paper, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SectionCard = ({
  title,
  description,
  children,
  headerAction,
  borderRadius = "18px",
  sectioned = false,
  px = 3,
  pt = 3,
  pb = 3,
  mb = 2,
  mt = 0,
  flat = false,
  hideTopDivider = false,
  sx,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        mb: mb,
        mt: mt,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          backgroundColor: flat
            ? "transparent"
            : theme.palette.mode === "light"
              ? "rgba(255,255,255,0.96)"
              : "rgba(15, 23, 42, 0.34)",
          borderRadius: flat ? 0 : borderRadius,
          padding: theme.spacing(px),
          paddingTop: theme.spacing(pt),
          paddingBottom: theme.spacing(pb),
          paddingLeft: isMobile && flat ? theme.spacing(2) : undefined,
          paddingRight: isMobile && flat ? theme.spacing(2) : undefined,
          border: flat ? "none" : `1px solid ${theme.palette.grey[200]}`,
          borderTop: undefined,
          borderBottom: undefined,
          boxShadow: flat ? "none" : "0 1px 2px rgba(15, 23, 42, 0.04)",
          mt: flat && isMobile ? 1.5 : mt,
          ...(isMobile &&
            !flat && {
              borderRadius: "16px",
              paddingLeft: theme.spacing(2),
              paddingRight: theme.spacing(2),
              paddingTop: theme.spacing(2.25),
              paddingBottom: theme.spacing(2.25),
            }),
          ...sx,
        }}
      >
        {title && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "space-between",
              mb: flat ? 1 : 1.5,
              ml: 0,
            }}
          >
            <Typography
              variant={flat ? "subtitle1" : "h4"}
              component="h2"
              sx={{
                fontWeight: flat ? 700 : 600,
                fontSize: flat
                  ? { xs: "0.96rem", sm: "1rem" }
                  : { xs: "1rem", sm: "1.08rem" },
                lineHeight: 1.3,
                letterSpacing: 0,
                color: "text.primary",
              }}
            >
              {title}
            </Typography>
            {headerAction}
          </Box>
        )}
        {description && (
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: flat ? 2.5 : 3,
              lineHeight: 1.6,
              maxWidth: flat ? 720 : undefined,
              fontSize: { xs: "0.78rem", sm: "0.85rem" },
            }}
          >
            {description}
          </Typography>
        )}

        {sectioned
          ? React.Children.map(children, (child, index) => (
              <React.Fragment key={index}>
                {index > 0 && (
                  <Divider
                    sx={{
                      my: 4,
                      borderColor: theme.palette.grey[200],
                    }}
                  />
                )}
                {child}
              </React.Fragment>
            ))
          : children}
      </Paper>
    </Box>
  );
};

export default SectionCard;
